import { Checkbox, Form, InputNumber, Select, Switch, Col, Row } from 'antd';
import DatePicker from '../../dateFnsComponents/DatePicker';
import { ShipOptionSelect } from '~/components/printLabelTool/sections/ShipOptions/ShipOptionSelect';
import { CarrierServiceMethodSelect } from '~/components/printLabelTool/sections/ShipOptions/CarrierServiceMethodSelect';
import { useStoreState } from '~/store';
import { CarrierListMode } from '~/store/simulation/types';

const { Item } = Form;
const { Option } = Select;

export const ShipmentOptionsForm = () => {
  const partnerId = useStoreState((state) => state.partner.activePartner?.partnerId);
  const ignoreCarrierServiceMethodAllowList = Form.useWatch('ignoreCarrierServiceMethodAllowList');
  const carrierListMode = Form.useWatch('carrierListMode') || CarrierListMode.ALLOW;
  const isAllowList = carrierListMode === CarrierListMode.ALLOW;

  return (
    <div>
      <Item
        name={'productDetails'}
        label={<b>Product Details</b>}
        style={{ marginBottom: 0 }}
        wrapperCol={{ span: 23, offset: 1 }}
      >
        <Checkbox.Group style={{ width: '100%', marginBottom: '10px' }}>
          <Checkbox key="hazmat" value="hazmat" style={{ lineHeight: '32px' }}>
            Hazmat
          </Checkbox>
          <Checkbox key="Li-ion" value="lithiumIon" style={{ lineHeight: '32px' }}>
            Lithium Ion
          </Checkbox>
          <Checkbox key="LQ" value="limitedQuantity" style={{ lineHeight: '32px' }}>
            Limited Quantity
          </Checkbox>
        </Checkbox.Group>
      </Item>
      <Item
        name={'ignoreRuleSets'}
        label={'Ignore Rule Sets'}
        extra={
          'If you are utilizing rules in your production configuration, you can use this toggle to ignore them for this simulation'
        }
        valuePropName="checked"
      >
        <Switch checkedChildren={'Ignore'} />
      </Item>
      {!ignoreCarrierServiceMethodAllowList && (
        <Item
          label={isAllowList ? 'Carrier Service Method Allow List' : 'Carrier Service Method Exclusion List'}
          extra={
            isAllowList
              ? 'Select carriers/service methods you would like to include in the simulation. If left blank, all will be included.'
              : 'Select carriers/service methods you would like to exclude from the simulation. All others will be included.'
          }
        >
          <Row gutter={12}>
            <Col span={3}>
              <Item name={'carrierListMode'} noStyle initialValue={CarrierListMode.ALLOW}>
                <Select defaultValue={CarrierListMode.ALLOW} style={{ width: '100%' }} size="middle">
                  <Option value={CarrierListMode.ALLOW}>Allow</Option>
                  <Option value={CarrierListMode.EXCLUDE}>Exclude</Option>
                </Select>
              </Item>
            </Col>
            <Col span={21}>
              <Item name={'carrierServiceMethodList'} noStyle>
                <CarrierServiceMethodSelect
                  partnerId={partnerId}
                  filterNonConfiguredServiceMethods
                  placeholder={
                    isAllowList
                      ? 'Select carrier service methods to allow'
                      : 'Select carrier service methods to exclude'
                  }
                  multiple
                  style={{ width: '100%' }}
                />
              </Item>
            </Col>
          </Row>
        </Item>
      )}
      <Item
        name={'ignoreCarrierServiceMethodAllowList'}
        label={'Ignore Carrier Service Method Allow List'}
        extra={
          'If your historical data has carrier service method allow lists defined at the shipment level, you can use this toggle to ignore them for this simulation'
        }
        valuePropName="checked"
      >
        <Switch checkedChildren={'Ignore'} />
      </Item>
      <Item name={'shipOption'} label={'Ship Option'}>
        <ShipOptionSelect style={{ width: 'calc(40% - 12px)' }} />
      </Item>
      <Item name="destinationIsPOBox" label="Destination is PO Box" valuePropName={'checked'}>
        <Switch />
      </Item>
      <Item name={'destinationAddressType'} label="Destination Address Type">
        <Select placeholder="Select address type">
          <Option value="residential">Residential</Option>
          <Option value="commercial">Commercial</Option>
        </Select>
      </Item>
      <Item name={'desiredDeliveryDate'} label="Desired Delivery Date">
        <DatePicker style={{ width: '100%' }} />
      </Item>
      <Item name={'timeInTransitDays'} label="Time In Transit Days">
        <InputNumber min={0} style={{ width: '100%' }} />
      </Item>
      <Item name={'businessDaysOfTransit'} label="Business Days Of Transit">
        <InputNumber min={0} style={{ width: '100%' }} />
      </Item>
    </div>
  );
};
